import React, { useEffect } from 'react';
// import validator from 'validator';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { TextField, Box, Grid } from '@mui/material';
import { createState, useState, Downgraded } from '@hookstate/core';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Helper from '../../utility/helper';

const initalState = createState({
    id: -1,
    firstName: '',
    lastName: '',
    // relation: '',
});
const AddOccupant = (props) => {
    //console.log('occupant');
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [lastNameErr, setLastNameErr] = React.useState('');
    // const [relationErr, setRelationErr] = React.useState('');
    const guestState = createState(initalState);
    const [disableUpdateBtn, setDisableUpdateBtn] = React.useState(true);

    const state = useState(guestState);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const validateFirstName = () => {
        let value = state.firstName.get().trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach(x => {
                if (!Helper.isValidName(x))
                    isValid = false
            })
        } else {
            isValid = false
        }
        if (value == '') {
            setFirstNameErr('Please Enter  First Name');
            return { flag: 'false', messages: 'Please Enter  First Name' };
        } else if (!isValid) {
            setFirstNameErr('Please Enter Valid First Name');
            return { flag: 'false', messages: 'Please Enter Valid FirstName' };
        } else {
            setFirstNameErr('');
            return true;
        }
    };
    const validateLastName = () => {
        let value = state.lastName.get().trim();
        let isValid = true;
        if (value !== '') {
            value.split(' ').forEach(x => {
                if (!Helper.isValidName(x))
                    isValid = false
            })
        } else {
            isValid = false
        }
        if (value == '') {
            setLastNameErr('Please Enter Last Name');
            return { flag: 'false', messages: 'Please Enter Last Name' };
        }
        else if (!isValid) {
            setLastNameErr('Please Enter Valid Last Name');
            return { flag: 'false', messages: 'Please Enter Valid Last Name' };
        } else {
            setLastNameErr('');
            return true;
        }
    };

    // const validateRelation = () => {
    //     let value = state.relation.get().trim();
    //     if (value == '') {
    //         setRelationErr('Please Enter Relation Name');
    //         return { flag: 'false', messages: 'Please Enter Relation Name' };
    //     }
    //     if (validator.isAlpha(value)) {
    //         setRelationErr('');
    //         return true;
    //     } else setRelationErr('Please Enter Valid Relation');
    //     return { flag: 'false', messages: 'Please Enter Valid Relation Name' };
    // };

    useEffect(() => {
        // state.set(initalState);

        if (props.data != null) {
            state.set({
                id: props.data.id,
                firstName: props.data.firstName,
                lastName: props.data.lastName,
                // relation: props.data.relation,
            });
        } else {
            state.set({
                id: -1,
                firstName: '',
                lastName: '',
                // relation: '',
            });
        }
    }, [props]);

    const renderDialogContent = () => {
        return (
            <Box>
                <Box
                    sx={{
                        padding: 1,
                        '& .MuiFormControl-root': { width: '100%' },
                    }}>
                    <Grid
                        container
                        rowSpacing={2}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        sx={{
                            padding: 0,
                            marginTop: 1,
                        }}>
                        <Grid item lg={6} md={6} xs={12}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="First Name"
                                autoComplete="off"
                                value={state.firstName.attach(Downgraded).get()}
                                onChange={(event) => {
                                    state.firstName.set(event.target.value);
                                    setDisableUpdateBtn(false)
                                }}
                                error={firstNameErr.length > 0 ? true : false}
                                helperText={
                                    firstNameErr.length > 0 ? firstNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} xs={12}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="Last Name"
                                autoComplete="off"
                                value={state.lastName.attach(Downgraded).get()}
                                onChange={(event) => {
                                    state.lastName.set(event.target.value);
                                    setDisableUpdateBtn(false)
                                }}
                                error={lastNameErr.length > 0 ? true : false}
                                helperText={
                                    lastNameErr.length > 0 ? lastNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        {/*  <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                padding: 1,
                            }}>
                           <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="Relation"
                                autoComplete="off"
                                value={state.relation.attach(Downgraded).get()}
                                onChange={(event) => {
                                    state.relation.set(event.target.value);
                                }}
                                error={relationErr.length > 0 ? true : false}
                                helperText={
                                    relationErr.length > 0 ? relationErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            /> 
                        </Box>*/}
                    </Grid>
                </Box>
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
            </Box>
        );
    };

    const handleClick = () => {
        const fName = validateFirstName();
        const lName = validateLastName();
        // const relation = validateRelation();
        if (fName.flag === 'false') {
            // setSnackBarProps({
            //     ...snackBarProps,
            //     openSnack: true,
            //     variant: 'error',
            //     message: fName.messages,
            // });
            return;
        }
        if (lName.flag === 'false') {
            // setSnackBarProps({
            //     ...snackBarProps,
            //     openSnack: true,
            //     variant: 'error',
            //     message: lName.messages,
            // });
            return;
        }

        props.handleAction(
            state.firstName.attach(Downgraded).get(),
            state.lastName.attach(Downgraded).get(),
            // state.relation.attach(Downgraded).get(),
            state.id.get()
        );
    };

    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.data != null ? 'Update' : 'Create'}
                disableUpdateButton={disableUpdateBtn}
            />
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default AddOccupant;
